<template>
  <nx-form :value="value"
           class="nx-scrollytelling-slide-editor-form"
           validation-mode="eager"
           v-on="$listeners"
           ref="form"
           v-slot="{ draft, form }">
    <nx-scrollytelling-slide-configuration-scope :draft="draft"/>
    <nx-form-scope-card title="Html" icon="html" class="mt-1" collapsable>
      <v-flex xs12>
        <nx-form-textarea name="html"
                          label="HTML"
                          validation="required"
                          :value="draft.html"/>
      </v-flex>
    </nx-form-scope-card>
    <nx-scrollytelling-slide-background-color-scope :draft="draft" />
  </nx-form>
</template>

<script>
import NxFormScopeCard from '@/modules/form/components/FormScopeCard';
import NxForm from '@/modules/form/Form';
import NxScrollytellingSlideConfigurationScope
  from '@/modules/scrollytelling/components/form/components/ScrollytellingSlideConfigurationScope';
import NxFormTextarea from '@/modules/form/components/FormTextarea';
import NxScrollytellingSlideBackgroundColorScope
  from '@/modules/scrollytelling/components/form/components/ScrollytellingSlideBackgroundColorScope';

export default {
  name: 'nx-scrollytelling-slide-editor-form-html',
  components: {
    NxScrollytellingSlideBackgroundColorScope,
    NxFormTextarea,
    NxScrollytellingSlideConfigurationScope,
    NxForm,
    NxFormScopeCard,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
};
</script>
